import { getApiBaseUrl } from '../../../utils/apiConfig';

const URL = () => `${getApiBaseUrl()}/api/pg-native/config/completion-status`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken') || ''}` });

/** { nativeOperation, data: { erpCode, name, source } | null } */
export async function fetchCompletionStatus() {
  const res = await fetch(URL(), { headers: auth() });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao carregar o status de conclusão');
  return { nativeOperation: !!j.nativeOperation, data: j.data || null };
}

/** Status cadastrado com o código ({ erpCode, name, source }) ou null quando será um status novo. */
export async function lookupCompletionStatus(code) {
  const res = await fetch(`${URL()}/lookup?code=${encodeURIComponent(code)}`, { headers: auth() });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao consultar o status');
  return j.data || null;
}

export async function saveCompletionStatus(erpCode, name) {
  const res = await fetch(URL(), {
    method: 'PUT',
    headers: { ...auth(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ erpCode, name }),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j.success) throw new Error(j.message || 'Erro ao salvar o status de conclusão');
  return j.data;
}
